import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import PollListTable from '../Util/PollListTable';
import request from '../../util/request';


export default class PollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading1: true,
            pollList: [],
            allPollList: [],
            pollActiveList: [],
            excelData: [],
            admin: !!localStorage.getItem('activeRole').includes('QA admin:'),
            orgUnits: [],
            orgUnitId: '',

        };
        this.getOrgUnitName = this.getOrgUnitName.bind(this);
    }
    componentDidMount() {
        request.fetchOrgUnits()
            .then(orgUnits => this.setState({ orgUnits }));

        localStorage.removeItem('courseId');
        localStorage.removeItem('spId');
        localStorage.removeItem('poll');
        localStorage.removeItem('organizationalUnitEmployeeId');
        localStorage.removeItem('courseImplementationGroupId');
        localStorage.removeItem('courseName');
        localStorage.removeItem('numberOfStudentsWhoRatedEmployee');
        localStorage.removeItem('numberOfStudentsWhoRatedCourse');
        axios.get('questionnaire/all/3/')
            .then(res => {
                // const pollList = res.data;
                // this.setState({ pollList, loading: false });
                const savedOrgUnitId = this.state.admin && localStorage.getItem('organizationalUnitId')
                    ? JSON.parse(localStorage.getItem('organizationalUnitId'))
                    : '';

                const filteredPolls = savedOrgUnitId
                    ? res.data.filter(el =>
                        el.organizationalUnits &&
                        el.organizationalUnits.some(ou => ou.id === savedOrgUnitId)
                    )
                    : res.data;

                this.setState(
                    {
                        allPollList: res.data,
                        orgUnitId: savedOrgUnitId,
                        pollList: filteredPolls.map(el => ({
                            ...el,
                            type: el.questionnaireType.name,
                            activationDate: el.activationDate ? moment(el.activationDate).format('D. M. YYYY.') : '',
                            endDate: el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '',
                        })),
                        loading: false,
                    },
                    () => {
                        this.setState({
                            excelData: this.state.pollList.map((el, index) => ([
                                { value: (index + 1) + '.' },
                                { value: el.name },
                                { value: el.questionnaireType.name },
                                { value: el.activationDate },
                                { value: el.endDate }
                            ]))
                        });
                    }
                );
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });

        axios.get('questionnaire/all/2/')
            .then(res => {
                const pollActiveList = res.data;
                this.setState({ pollActiveList, loading1: false });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }

    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.pollList;
    }

    getOrgUnitName(id){
        const { orgUnits } = this.state;
        const selected = orgUnits.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    handleOrgUnitChange = (orgUnitId) => {
        const filteredPolls = orgUnitId
            ? this.state.allPollList.filter(el =>
                el.organizationalUnits &&
                el.organizationalUnits.some(ou => ou.id === orgUnitId)
            )
            : this.state.allPollList;

        this.setState({
            orgUnitId,
            pollList: filteredPolls.map(el => ({
                ...el,
                type: el.questionnaireType.name,
                activationDate: el.activationDate ? moment(el.activationDate).format('D. M. YYYY.') : '',
                endDate: el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '',
            })),
            excelData: filteredPolls.map((el, index) => ([
                { value: (index + 1) + '.' },
                { value: el.name },
                { value: el.questionnaireType.name },
                { value: el.activationDate ? moment(el.activationDate).format('D. M. YYYY.') : '' },
                { value: el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '' }
            ]))
        });

        localStorage.setItem('organizationalUnitId', orgUnitId);
        localStorage.setItem('orgUnitName', this.getOrgUnitName(orgUnitId));
    }

    render() {
        return (

            <div>
                <Header as="h1">  {this.state.admin ? 'Rezultati' : 'Ankete'} </Header>
                {/* <Segment.Group clearing raised > */}
                {/*    <Segment> <Header as="h3"> Aktivne ankete </Header></Segment> */}

                {/*    <Segment> */}
                {/*        { this.state.loading1 ? */}
                {/*            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}> */}
                {/*                <Loader active inline="centered" /> */}
                {/*            </div> : */}
                {/*            <PollListTable */}
                {/*                polls={this.state.pollActiveList} */}
                {/*                active */}

                {/*            />} */}
                {/*    </Segment> */}

                {/* </Segment.Group> */}
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> Završene ankete </Header></Segment>

                    {this.state.admin && <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.orgUnits}>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.orgUnitId}
                                        onChange={(e, { value }) => this.handleOrgUnitChange(value)}
                                        name="orgUnit"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>

                        </Form>
                    </Segment>
                    }

                    {((this.state.admin && this.state.orgUnitId) || !this.state.admin) && <Segment>
                        { this.state.loading ?
                            <div style={{ paddingTop: '100px', paddingBottom: '100px' }}>
                                <Loader active inline="centered" />
                            </div> :
                            <PollListTable
                                polls={this.state.pollList}
                                rowRedirect={this.state.admin ? "/rezultati/osoblje" : "/ankete/osoblje"}
                                firstButtonLink={this.state.admin ? "/rezultati/osoblje" : "/ankete/osoblje"}
                                firstAltButtonLink={this.state.admin ? "/rezultati/sp" : "/ankete/sp"}
                                firstAltButtonText="Studijski programi"
                                firstButtonText="Akademsko osoblje"
                                admin={this.state.admin}
                            />}
                    </Segment>}

                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/QAPoll/PollList.js